import { createRouter, createWebHistory } from 'vue-router'
import SignDocumentVue from '../views/SignDocument.vue'
import SuccessPage from '../views/SuccessPage.vue'
import ErrorPage from '../views/ErrorPage.vue' // Create this component

const routes = [
    {
        path: '/',
        redirect: '/error'
    },
    {
        path: '/agreement/:token',
        name: 'agreement',
        component: SignDocumentVue,
        props: true,
        beforeEnter: (to, from, next) => {
            // Validate token exists
            if (!to.params.token) {
                next('/error')
            } else {
                next()
            }
        }
    },
    {
        path: '/success',
        name: 'success',
        component: SuccessPage,
        beforeEnter: (to, from, next) => {
            // Only allow access from agreement page
            if (from.name === 'agreement') {
                next()
            } else {
                next('/error')
            }
        }
    },
    {
        path: '/error',
        name: 'error',
        component: ErrorPage
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/error'
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router